// extracted by mini-css-extract-plugin
export default {"flex":"TableTextBottom_flex__mpCYi"};